import { jsx as _jsx } from "react/jsx-runtime";
import gemCategoryParseIcon from '../../../assets/new_gems/Category/GemCategoryParse.svg?inline';
export const GemCategoryParse = (props) => {
    return _jsx("img", { ...props, src: gemCategoryParseIcon, alt: 'GemCategoryParseImage' });
};
